export default __webpack_public_path__ + "static/media/bookmark-icon-active.27dbccb9.svg";